module.exports = __webpack_public_path__ + "img/title.7010a9e9.png";